// 防抖
export class Debounce {
  constructor() {
    this.timer = null
  }
  debounce(fn, delay) {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    this.timer = setTimeout(fn, delay) // 简化写法
  }
}
// 节流
export class Throttle {
  constructor() {
    this.valid = true
  }
  throttle(fn, delay) {
    if (!this.valid) {
      // 休息时间 暂不接客
      return false
    }
    // 工作时间，执行函数并且在间隔期内把状态位设为无效
    this.valid = false
    setTimeout(() => {
      fn()
      this.valid = true
    }, delay)
  }
}
export const throttle = (fn, delay) => {
  let valid = true
  return function() {
    if (!valid) {
      // 休息时间 暂不接客
      return false
    }
    // 工作时间，执行函数并且在间隔期内把状态位设为无效
    valid = false
    setTimeout(() => {
      fn()
      valid = true
    }, delay)
  }
}

/**
 * 存localStorage,并加上逻辑时间
 * @param key
 * @param value
 * @param duration 天数
 */
export const setLocal = (key, value, duration) => {
  var data = {
    value: value,
    expiryTime: !duration || isNaN(duration) ? 0 : new Date().getTime() + parseInt(duration * 24 * 60 * 60 * 1000)
  }
  localStorage[key] = JSON.stringify(data)
}
/**
 * 取localStorage,并根据逻辑时间附上有效性
 * @param key
 * @returns {*}
 */
export const getLocal = (key) => {
  var data = localStorage[key]
  if (!data || data === 'null') {
    return null
  }
  var now = new Date().getTime()
  var obj
  try {
    obj = JSON.parse(data)
  } catch (e) {
    return null
  }
  if (obj.expiryTime === 0 || obj.expiryTime > now) {
    return obj.value
  }
  return null
}
/**
 * 删除LocalStorage
 * @param key
 */
export const removeLocal = (key) => {
  localStorage.removeItem(key)
}
/**
 * 简单数组去重
 * @param array
 * @returns {Array}
 */
export const unRepeat = (array) => {
  return [...new Set(array)]
}
/**
 * 图片转字符串
 * @param array
 * @returns String
 */
export const img2String = (array) => {
  if (array.length) {
    return array.map(item => {
      return item.key
    }).join()
  } else {
    return ''
  }
}
/**
 * 深拷贝
 * @param Object
 */
export const deepClone = (source) => {
  const targetObj = source.constructor === Array ? [] : {}
  for (const keys in source) {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  }
  return targetObj
}
/**
 * 保留n个后...
 * @param str
 * @param n
 * @returns {*}
 */
export const ellipsis = (str, n) => {
  return str.length > n ? str.slice(0, n) + '...' : str
}

export const moneyNum = (money, n = 2) => {
  const f = parseFloat(money)
  if (isNaN(f)) {
    return money
  }
  return f.toFixed(n)
}
export const isNumber = (val) => {
  var regPos = /^\d+(\.\d+)?$/ // 非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
  return regPos.test(val) || regNeg.test(val)
}
export const numCount = (val, attach = '') => {
  if (val) {
    if (val >= 1000 && val < 10000) {
      return !attach ? `${moneyNum(val / 1000, 1)}k` : `${parseInt(val / 1000)}k${attach}`
    } else if (val >= 10000) {
      return !attach ? `${moneyNum(val / 10000, 1)}w` : `${parseInt(val / 10000)}w${attach}`
    }
    return val
  }
  return 0
}

export const isExtranet = (url) => {
  url = url.toString()
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('www')) {
    return true
  } else if (url.startsWith('/')) {
    return false
  }
  return false
}

export const isJSON = (str) => {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  }
}
/**
 * 对对象数据进行初始化，数组、对象、数字、字符串、布尔值默认初始化后的值分别为 [], {}, 0, '', false
 * @param form { Object } 要初始化的表单数据
 * @param customFormData { Object } 需要自定义初始化的表单数据
 */
export const initObjData = (form, customFormData = {}) => {
  for (const key in form) {
    const isCustom = key in customFormData
    if (![undefined, null].includes(form[key])) {
      switch (form[key].constructor) {
        case Array:
          if (isCustom && ![undefined, null].includes(customFormData[key])) {
            form[key] = [...customFormData[key]]
          } else {
            form[key] = []
          }
          break
        case Object:
          if (isCustom && ![undefined, null].includes(customFormData[key])) {
            form[key] = { ...customFormData[key] }
          } else {
            form[key] = {}
          }
          break
        case String:
          if (isCustom) {
            form[key] = customFormData[key]
          } else {
            form[key] = ''
          }
          break
        case Number:
          if (isCustom) {
            form[key] = customFormData[key]
          } else {
            form[key] = 0
          }
          break
        case Boolean:
          if (isCustom) {
            form[key] = customFormData[key]
          } else {
            form[key] = false
          }
          break
        default:
          if (isCustom) {
            form[key] = customFormData[key]
          } else {
            form[key] = null
          }
      }
    } else {
      if (isCustom) {
        form[key] = customFormData[key]
      }
    }
  }
}
/**
 * 获取对应svg类型icon
 * @param String
 * @return String
 */
export const getSvg = (cateName) => {
  switch (cateName) {
    case '种子':
      return 'seed'
    case '农药':
      return 'pesticide'
    case '肥料':
      return 'fertilizer'
    case '农用工具':
      return 'tool'
    case '退货':
      return 'tally_returnGood'
    case '人工费':
      return 'tally_rengong'
    case '硬件设施':
      return 'tally_yingjian'
    case '水电':
      return 'tally_shuidian'
    // 收入
    case '卖果':
      return 'tally_sellfruit'
    case '政府补贴':
      return 'tally_zfbutie'
    case '卖苗':
      return 'tally_sellseed'
    case '添加':
      return 'add'
    default:
      return 'tally_normal'
  }
}
